export type BillingConfirmationKind =
  | 'skipTrial'
  | 'cancelTrial'
  | 'cancelSubscription'
  | 'upgradeSubscription';

export type BillingConfirmationCopy = {
  title: string;
  message: string;
  warningMessage?: string;
  confirmText: string;
  variant: 'default' | 'danger';
};

export const BILLING_CONFIRMATIONS: Record<BillingConfirmationKind, BillingConfirmationCopy> = {
  skipTrial: {
    title: 'End trial & unlock full plan?',
    message:
      'Your card will be charged today and your full plan limits unlock immediately.',
    confirmText: 'End trial & unlock plan',
    variant: 'default',
  },
  cancelTrial: {
    title: 'Cancel trial?',
    message: 'You will not be charged.',
    warningMessage: 'Access may end immediately.',
    confirmText: 'Cancel trial',
    variant: 'danger',
  },
  cancelSubscription: {
    title: 'Cancel subscription?',
    message: 'Your subscription will cancel at the end of the current billing period.',
    confirmText: 'Cancel subscription',
    variant: 'danger',
  },
  upgradeSubscription: {
    title: 'Upgrade plan?',
    message:
      'Your plan upgrades immediately within your current module. Stripe will charge your saved payment method. Cross-module switches are handled by our team.',
    confirmText: 'Upgrade plan',
    variant: 'default',
  },
};
